module.exports = __webpack_public_path__ + "img/5m-sprint.cb82c80f.png";